import { getToken } from "../../authStore";

export async function getInvitationTokenList() {
  let token = getToken();
  try {
    const req = await fetch(
      `${process.env.API_URL}/api/invitation-tokens/list`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${token}`,
        },
      }
    ).then((res) => res.json());
    console.log("getInvitationTokenList: response, ", req?.docs);
    return req?.docs;
  } catch (err) {
    console.log("getInvitationTokenList: error, ", err);
  }
}
